import { Component, Input, OnInit } from "@angular/core"
import Utils from "../../utils/utils"
import { NotificationsService } from "angular2-notifications"

@Component({
    selector: "app-copy-link",
    templateUrl: "./copy-link.component.html",
    styleUrls: ["./copy-link.component.scss"],
})
export class CopyLinkComponent implements OnInit {
    @Input() public shareLink: string = ""

    constructor(private notificationsService: NotificationsService) {}

    public ngOnInit() {
        this.shareLink = this.shareLink ? this.shareLink : window.location.href
    }

    public copyLink(id) {
        Utils.copyTextToClipboard(this.shareLink)
        this.notificationsService.success(
            "Link copied",
            "The link was copied to clipboard",
            Utils.alertConfiguration
        )
    }
}
